export const KpiTileGroupWidgetId = 'KpiTileGroupWidget';

export enum KpiTileGroupWidgetAttributes {
  ID = 'kpiId',
  KPI_TILE = 'kpiTile',
}
